import { useAppDispatch, useAppSelector } from "@app/store";
import { useUserId } from "@hooks/use-user-id";
import { useCallback } from "react";
import {
  ActivateRequisiteForm,
  CreateRequisiteForm,
  EnableRequisiteForm,
  RequisiteForm,
  UpdateRequisiteForm,
} from "./api";
import {
  activateRequisite,
  createRequisite,
  enableRequisite,
  getOrderRequisites,
  getRequisite,
  getRequisites,
  removeRequisite,
  updateRequisite,
} from "./slice";

export const useRequisites = () => {
  const state = useAppSelector((state) => state.requisite);

  const methods = useRequisitesDispatch();

  return {
    state,
    ...methods,
  };
};

export const useRequisitesDispatch = () => {
  const userId = useUserId();

  const dispatch = useAppDispatch();

  const getRequisitesHandler = useCallback(
    (data: RequisiteForm) => dispatch(getRequisites({ userId, data })),
    [dispatch, userId]
  );

  const createRequisiteHandler = useCallback(
    (data: Omit<CreateRequisiteForm, "userId">) =>
      dispatch(createRequisite({ ...data, userId })).unwrap(),
    [dispatch, userId]
  );

  const removeRequisiteHandler = useCallback(
    (requisiteId: string) => dispatch(removeRequisite(requisiteId)).unwrap(),
    [dispatch]
  );

  const getRequisiteHandler = useCallback(
    (requisiteId: string) => dispatch(getRequisite(requisiteId)),
    [dispatch]
  );

  const updateRequisiteHandler = useCallback(
    (data: UpdateRequisiteForm) => dispatch(updateRequisite(data)).unwrap(),
    [dispatch]
  );

  const activateRequisiteHandler = useCallback(
    (data: ActivateRequisiteForm) =>
      dispatch(activateRequisite({ userId, data })).unwrap(),
    [dispatch, userId]
  );

  const enableRequisiteHandler = useCallback(
    (requisiteId: string, data: EnableRequisiteForm) =>
      dispatch(enableRequisite({ id: requisiteId, data })).unwrap(),
    [dispatch]
  );

  return {
    getRequisite: getRequisiteHandler,
    getRequisites: getRequisitesHandler,
    createRequisite: createRequisiteHandler,
    removeRequisite: removeRequisiteHandler,
    updateRequisite: updateRequisiteHandler,
    activateRequisite: activateRequisiteHandler,
    enableRequisite: enableRequisiteHandler,
  };
};

export const useOrderRequisites = () => {
  const state = useAppSelector((state) => state.requisite);
  const dispatch = useAppDispatch();

  const getOrderRequisitesHandler = useCallback(
    (orderId: string) => dispatch(getOrderRequisites({ orderId })),
    [dispatch]
  );

  // const confirmOrderHandler = useCallback(
  //   (orderId: string) => dispatch(confirmOrder({ userId, orderId })),
  //   [dispatch, userId]
  // );

  return {
    state,
    getOrderRequisites: getOrderRequisitesHandler,
    // confirmOrder: confirmOrderHandler,
  };
};
